import React, { useEffect, useRef } from 'react';
import { update } from 'jdenticon';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  profileImg: {
    borderRadius: '30px',
    marginLeft: 5,
  },
}));

const ProfileImage = ({ name, width = '80', height = '80' }) => {
  const svgRef = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    if (svgRef.current) {
      update(svgRef.current, name);
    }
  }, [name]);

  return (
    <svg
      ref={svgRef}
      width={width}
      height={height}
      className={classes.profileImg}
    />
  );
};

export default ProfileImage;
